import { Toast } from '@/utils';

export const ERR_CODE_2_TEXT = {
  ERR_NETWORK: '网络错误',
  ERR_TIMED_OUT: '请求超时',
  ERR_SSL_PROTOCOL_ERROR: 'SSL协议错误',
  ERR_CANCELED: '请求取消',
};

export default function errorHandler(error: any) {
  Toast.show('无法连接到机器人，请检查网络连接状态');
  return Promise.reject(error);
}

export function errorHandlerWithMessage(error: any) {
  Toast.fail(
    ERR_CODE_2_TEXT[error?.code] || error?.response?.data?.messagae || error?.message || error?.msg || '网络错误'
  );

  return Promise.reject(error);
}

export const restfulErrorHandler = (error: any) => {
  return Promise.reject(error);
};
